import React from "react";
import { useSelector } from "react-redux";
import LoadingFullPage from "../../components/common/Loading/LoadingFullPage";
import getOrderNeccesaryData from "../../helpers/getOrderNeccesaryData";
import useFullscreenStatus from "../../hooks/useFullscreenStatus";
import useKitchenDisplay from "../../hooks/useKitchenDisplay";
import { useDispatch } from "react-redux";
import { getAllBrancheCustomer } from "../../redux/action/branchActions";
import { getAllItemAvailability } from "../../redux/action/itemAvailability";
import {
  getOfflineActiveOrders,
  getOfflineAllItems,
  getOfflineTables,
  getOfflineAllTables,
  getOfflineItemCategories,
  getOfflineUser,
  getOfflineItemAvailability,
  getOfflineLastOrderNumber,
  activateOrderOffline,
  pushItemToActiveOrderOffline,
} from "../../redux/action/offlineDataActions";
import getoffiledata from "../../helpers/readOfflineData";
import {
  setKOTitemsData,
  activateOrder,
  setActiveOrder,
  pushItemToActiveOrder,
} from "../../redux/action/orderActions";
import { FormProvider, useForm } from "react-hook-form";
import MobileOrderDashboard from "./MobileView/MobileOrderDashboard";
import NewDesktopDashboard from "./NewDesktopDashboard";
import "./ResponsiveOrderDashboard.css";
import haptics from "../../helpers/haptics";

const OrderDashboard = () => {
  const isElectron = window?.api?.isElectron;
  const { isOnline, isAppOffline } = useSelector(
    (state) => state.networkStatus
  );
  const dispatch = useDispatch();
  const [isMobileView, setIsMobileView] = React.useState(false);

  const ready = getOrderNeccesaryData();
  const kitchen = useKitchenDisplay();

  const isFullScreen = useSelector((state) => state.util.isFullScreen);

  const ref = React.useRef(null);

  const { branchId, name: username } = useSelector((state) => state.user);
  const { activeOrders, allTables } = useSelector((state) => state.order);
  const { tables } = useSelector((state) => state.branch);

  // Check for mobile view
  React.useEffect(() => {
    const checkMobileView = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    checkMobileView();
    window.addEventListener("resize", checkMobileView);

    return () => window.removeEventListener("resize", checkMobileView);
  }, []);

  React.useEffect(async () => {
    if (isElectron && (isAppOffline || !isOnline)) {
      // const data = await getoffiledata()
      // window.api.createFileOffline({fileName: "log", data: await getoffiledata("activeOrders")})
      dispatch(getOfflineActiveOrders(await getoffiledata("activeOrders")));
      dispatch(getOfflineAllItems(await getoffiledata("allItems")));
      dispatch(getOfflineTables(await getoffiledata("tables")));
      dispatch(getOfflineAllTables(await getoffiledata("allTables")));
      dispatch(getOfflineItemCategories(await getoffiledata("itemCategories")));
      dispatch(getOfflineUser(await getoffiledata("user")));
      dispatch(
        getOfflineItemAvailability(await getoffiledata("itemAvailability"))
      );
      dispatch(getOfflineLastOrderNumber(await getoffiledata("orderCount")));
    } else {
      dispatch(getAllBrancheCustomer());
      dispatch(getAllItemAvailability());
    }
  }, [branchId]);

  const [isFullscreen, setIsFullscreen] = useFullscreenStatus(
    ref,
    isFullScreen
  );

  const methods = useForm();

  const handleKot = async (tableType, customerData, print) => {
    haptics.heavy();
    const onSubmit = methods.handleSubmit((data) => {
      dispatch(setKOTitemsData({ customerData: { ...customerData }, tableType }, print))
    });
    await onSubmit();
  };

  const handleCustomerForm = () => {
    const data = methods.getValues();
    return data;
  };

  // Mobile-specific handlers
  const checkactive = (tableNumber) => {
    let myIndex = activeOrders.find((table) => {
      return tableNumber === table.tableNumber;
    });

    if (myIndex) {
      return myIndex;
    } else {
      return false;
    }
  };

  const handleTableNumberClick = async (data, index) => {
    if (checkactive(data.tableNumber)) {
      dispatch(setActiveOrder(checkactive(data.tableNumber).refId));
    } else {
      if ((isAppOffline || !isOnline) && isElectron) {
        dispatch(getOfflineLastOrderNumber(await getoffiledata("orderCount")));
        dispatch(activateOrderOffline({ ...data }, username));
      } else {
        dispatch(activateOrder({ ...data }, username));
      }
    }
  };

  const handleOtherOrderClick = (data) => {
    dispatch(setActiveOrder(data.refId));
  };

  const handleItemClick = (item, isVariant) => {
    const activeOrder = activeOrders.find((order) => order.refId === activeOrders[0]?.refId);
    let tableType = tables.filter((table) => {
      return table?.tableNumber === activeOrder?.tableNumber;
    });

    if (activeOrder?.orderType === "Home Delivery") {
      tableType = [{ tableType: "Online" }];
    }

    if ((isAppOffline || !isOnline) && isElectron) {
      dispatch(pushItemToActiveOrderOffline({ item, isVariant, tableType }));
    } else {
      dispatch(pushItemToActiveOrder({ item, isVariant, tableType }));
    }
  };

  // const data = useKitchenDisplay();
  return ready ? (
    <>
      {isMobileView ? (
        <FormProvider {...methods}>
          <MobileOrderDashboard
            handleKot={handleKot}
            handleCustomerForm={handleCustomerForm}
            handleItemClick={handleItemClick}
            handleTableNumberClick={handleTableNumberClick}
            handleOtherOrderClick={handleOtherOrderClick}
          />
        </FormProvider>
      ) : (
        <FormProvider {...methods}>
          <NewDesktopDashboard
            handleKot={handleKot}
            handleCustomerForm={handleCustomerForm}
          />
        </FormProvider>
      )}
    </>
  ) : (
    <LoadingFullPage />
  );
};

export default OrderDashboard;

// import React from "react";
// import LoadingFullPage from "../../components/common/Loading/LoadingFullPage";
// import getOrderNeccesaryData from "../../helpers/getOrderNeccesaryData";
// import BottomPortion from "./BottomPortion";
// import CenterPortion from "./CenterPortion/index";
// import LeftPortion from "./LeftPortion/index";
// import RightPortion from "./RightPortion/index";
// import TopPortion from "./TopPortion";

// const styles = {
//   topStyle: {
//     height: "100%",
//     flex: 1,
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//     width: "100%",
//   },
// };
// const OrderDashboard = () => {
//   const ready = getOrderNeccesaryData();

//   return ready ? (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//         height: "100%",
//         overflow: "hidden",
//       }}
//     >
//       <div style={{ width: "100%" }}>
//         <TopPortion />
//       </div>
//       <div style={styles.topStyle}>
//         {/* <LeftPortion /> */}
//         <CenterPortion />
//         {/* <RightPortion /> */}
//       </div>
//       <div class="row" style={{ width: "100%" }}>
//         <BottomPortion />
//       </div>
//     </div>
//   ) : (
//     <LoadingFullPage />
//   );
// };

// export default OrderDashboard;
